// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"231070ad86f40439","5285":"6ef6b4d37f0a1a3a"}[chunkId] + ".css";
};